import React from 'react'
import { Link } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'

import { images } from '~assets/images'
import Button from '~components/internal/Button'
import Image from '~components/internal/Image'
import PageLayout from '~components/internal/PageLayout'
import Typography from '~components/internal/Typography'
import { internalLightTheme } from '~createInternalTheme'

import './PageNotFoundScreen.scss'

interface PageNotFoundScreenProps {
  permissionsError: boolean
  permissionMessage?: string
}

const PageNotFoundScreenContent: React.FC<PageNotFoundScreenProps> = ({
  permissionsError,
  permissionMessage,
}) => {
  const title = permissionsError ? 'Page Not Available' : 'Page Not Found'

  const description: React.ReactNode = permissionsError ? (
    permissionMessage ||
    "You don't seem to have permissions for this organization. Please reach out to your administrator if you need access"
  ) : (
    <>
      Uh oh, we can't seem to find the page you're looking for.
      <br />
      Try going back to the previous page.
    </>
  )

  return (
    <PageLayout hasTopMenu={false}>
      <div className='page-not-found'>
        <div className='page-not-found__blob-top-right'>
          <Image src={images.greenBlob} alt='' className='page-not-found__blob-image' />
        </div>
        <div className='page-not-found__layout'>
          <div className='page-not-found__spacer' />
          <div className='page-not-found__content'>
            <Typography variant='h1'>{title}</Typography>
            <Typography variant='h4' className='page-not-found__subtitle'>
              {description}
            </Typography>
            <Link to='/' className='page-not-found__button-link'>
              <Button variant='contained' color='primary'>
                Back to Home
              </Button>
            </Link>
          </div>
          <div className='page-not-found__flex-grow' />
          <div className='page-not-found__bottom'>
            <div className='page-not-found__blob-bottom-left'>
              <Image
                src={permissionsError ? images.blueBlob : images.titaniumBlob}
                alt=''
                className='page-not-found__blob-image'
              />
            </div>
            <Image
              src={images.quietStreetGraphic}
              alt='Quiet Street Graphic'
              className='page-not-found__illustration'
            />
          </div>
        </div>
      </div>
    </PageLayout>
  )
}

const PageNotFoundScreen: React.FC<PageNotFoundScreenProps> = (props) => {
  return (
    <ThemeProvider theme={internalLightTheme}>
      <PageNotFoundScreenContent {...props} />
    </ThemeProvider>
  )
}

export default PageNotFoundScreen
